<template>
  <div class="plan-information bg-2 rounded-16 p-4">
    <payment-methods v-model="form.payment_methods_ids" />

    <snow-select
      v-model="form.warranty"
      class="mt-5 mb-2"
      id="warranty"
      label="Garantia do produto *"
      :options="warranties"
    />

    <span class="text-dark-40 fs-14">
      Esse também é o prazo que o cliente tem para pedir reembolso. No Brasil, o
      prazo mínimo é de 7 dias e na União Europeia, de 15 dias.
    </span>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PaymentMethods from "./PaymentMethods.vue";

export default {
  components: {
    PaymentMethods
  },
  props: {
    plans: {
      type: Array,
      default: () => []
    },
    form: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("product", ["warranties"])
  }
};
</script>
